import React, { Component, Fragment } from 'react';
import ReactPlayer from 'react-player';

export default class Profile extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="container mt-5 bg">
                    <h1>Profile</h1>
                    <p>
                        Established in 2015, PT. Sinergi Karya Sejahtera ("PT SKS") is a company specializing in the field of mechanical and electrical, especially air conditioning system. With the support from our sister company, PT. Nelsindo Karya Sejahtera, which has been in the same business since 1988, PT. Sinergi Karya Sejahtera is able to grow to be one of the best mechanical / electrical contracting company in Indonesia.
                    </p>
                    <p>
                        In addition, PT. Sinergi Karya Sejahtera has also gained full support from several air-conditioning principals, which is given in the form of official certification. They also provide technical support, product knowledge, system design, supervision, maintenance as well as regular training from the principal to improve our competence in providing services.
                    </p>
                    <p>
                        During this time, PT. Sinergi Karya Sejahtera has handled several projects with both private and state-owned companies. The types of projects we have covered are office buildings, apartments, schools & universities, hospitals, factories, malls, hotels, places of worship and airports. In every project we work on, PT. Sinergi Karya Sejahtera always gives the best commitment to the customer. The commitment is in terms of cost, quality, time, and service. In addition, we also continue to enhance our expertise in order to always provide better service to our customers and to compete in the market.
                    </p>
                    <h1>Vision</h1>
                    <p>
                        To be a national private company specializing in the field of mechanical and electrical, especially in the Air Conditioning system in Indonesia that is always professional, reliable, and provides the best services and solutions.
                    </p>
                    <h1>Mision</h1>
                    <ul className="pl-3 pb-5">
                        <li>
                            Highly committed companies which are capable to produce an excellent quality of work, and provide outstanding service.
                        </li>
                        <li>
                            Establish good relationship with clients and business partners
                        </li>
                        <li>
                            Create a high quality system and standard in service
                        </li>
                    </ul>
                    <h1>Company Values</h1>
                    <ul className="pl-3 pb-5">
                        <li>
                            <h4>Professional</h4>
                            <p>
                                A national private company specializing in the field of mechanical and electrical, especially in the air conditioning system in Indonesia that always strives to be professional, reliable, and provide the best services and solutions.
                            </p>
                        </li>
                        <li>
                            <h4>Trusted</h4>
                            <p>
                                Highly committed company that produces an excellent quality of work, and provide outstanding services.
                            </p>
                        </li>
                        <li>
                            <h4>Providing Solutions</h4>
                            <p>
                                Offers expertise as one of the best mechanical and electrical contractor in its field.
                            </p>
                        </li>
                        <li>
                            <h4>Serving wholeheartedly</h4>
                            <p>
                                Create quality systems and standards in service.
                            </p>
                        </li>
                    </ul>
                </div>
            </Fragment>
        );
    }

}